export enum AnnotationType
{
    MAMMAL = "MAMMAL"
}